import styled from "styled-components";
import media from "styled-media-query";

export const FormApplication = styled.div`
  width: 641px;
  padding: 30px 75px 80px 67px;
  border-radius: 8px;
  background: #144BC8;

  ${media.lessThan("1489px", "1615px")`
    width: 481px;
	`}

  ${media.lessThan("1488px")`
    padding: 20px 65px 50px 47px;
    width: 581px;
	`}

  ${media.lessThan("1024px")`
    width: 100%;
		border-radius: 0;
  `}

  ${media.lessThan("576px")`
    padding: 40px 16px;
  `}

  ${media.between('1024px', '1367px')`
    max-width: 562px;
    padding: 20px 40px 40px 37px;
  `}

  ${media.lessThan('768px')`
    &.border {
      border: none;
      border-top: 10px solid #FFFFFF;
      box-shadow: none;
    }
  `}
	
	.headline {
    font-weight: 800;
    font-size: 28px;
    line-height: 34px;
    text-transform: uppercase;

    color: #FFFFFF;
    padding-right: calc(107px - 76px);
    margin-bottom: 16px;

    &.number {
      text-align: center;
    }

    ${media.lessThan("576px")`
			font-size: 24px;
		`}

    ${media.between('1024px', '1367px')`
      font-size: 22px;
      line-height: 26px;
      margin-bottom: 5px;
    `}
  }

  .form {
    
    &:not(:first-child) {
      margin-top: 24px;
    }

    .input-action {
      ${media.lessThan("576px")`
        justify-content: center;
      `}
    }

    .content-error {
      width: 48%;
      float: right;
      padding: 1px 2px;
      
      ${media.lessThan("768px")`
        width: 100%;
        float: none;
      `}
    }

    .content-error2 {
      width: 100%;
      margin-bottom: 5px;
    }

    .msg-error {
      margin: 2px 0 0 2px;
      font-size: 0.6rem;
      color: #f5cf46;
    }

    .content-error3 {
      margin-top: 5px;
    }

    label{
      a{
        font-weight: 700;
        text-decoration: underline;
      }
    }

    ${media.between('1024px', '1367px')`
      input {
        height: 40px;
        font-size: 12px;
        padding: 0 25px;

        & + input {
          margin
        }
      }

      label {
        font-size: 10px;
      }

      button {
        height: 40px;
        width: 130px;
        font-size: 10px;
      }
    `}

    .register {
      display: flex;
      align-items: flex-start;
      width: 100%;
      height: 244px;
      padding-top: 20px;

      ${media.between('1024px', '1367px')`
        height: 300px;
      `}
      
      .buttons {
        display: flex;
        width: 100%;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
      }
      
      .numbers {
        display: flex;
        width: 100%;
        flex-direction: column;
        
        > ul {
          list-style: none;

          > li {
            padding: 0 10px;
            font-size: 1rem;
          }
        }
      }

      > form {
        width: 100%;

        .input-group {
          margin-bottom: 20px;
        }
      }

      .btn-is-code {
        display: flex;
        flex-direction: row;

        .space {
          width: 20px;
        }
      }
    }
  }

  .form.form-number {
    display: none;
    ${media.lessThan("1024px")`
      display: block;
    `}
  }

  .link-relembrar-numero {
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-decoration-line: underline;
    color: #FFFFFF;
    margin-top: 25px;
    display: block;

    ${media.between('1024px', '1367px')`
      font-size: 10px;
      line-height: 14px;
      margin-top: 12px;
    `}

    ${media.lessThan("1024px")`
      text-align: center;
      padding: 0 calc(70px - 24px);
    `}
  }

  ${media.between('1024px', '1367px')`
    .input-action {
      margin-top: 12px;
    }

    .input-group, .input-group-grid {
      margin-top: 8px;
    }
    .input-group-grid .input-group {{
      margin-top: 0;
    }
    button {
      height: 30px;
      width: 130px;
      font-size: 8px;
    }
  `}
`;
